import React from 'react';
import basicStyles from './basic-grid.module.scss';

const SimpleBasicGrid: React.FC = () => {
  return (
    <>
      <h1>Auto fill</h1>
      <div className={basicStyles.basicGrid}>
        <div className={basicStyles.card}>1</div>
        <div className={basicStyles.card}>2</div>
        <div className={basicStyles.card}>3</div>
        <div className={basicStyles.card}>4</div>
        <div className={basicStyles.card}>5</div>
        <div className={basicStyles.card}>6</div>
        <div className={basicStyles.card}>7</div>
        <div className={basicStyles.card}>8</div>
        <div className={basicStyles.card}>9</div>
        <div className={basicStyles.card}>10</div>
        <div className={basicStyles.card}>11</div>
        <div className={basicStyles.card}>12</div>
      </div>
    </>
  );
};

export default SimpleBasicGrid;
